module.exports = __webpack_public_path__ + "img/Tucker-t-22984-011.7f0560a8.jpg";